import React from 'react'
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../../Redux/userReducer';
import { useHistory } from "react-router-dom";
import { setCompany, setCompanyUser, setWorkers } from '../../Redux/companyReducer';
import { useTranslation } from '../../hooks/useTranslation';
import apiService from '../../services/api.service';


function CompanyHeader({ chainId, urlParams, isLoading, setIsLoading, lang }) {
    const { t } = useTranslation();

    const dispatch = useDispatch()
    const history = useHistory()
    const company = useSelector((state) => state.company.company)
    const companyUser = useSelector((state) => state.company.companyUser)

    const logout = () => {
        dispatch(setUser(null))
        dispatch(setCompanyUser(null))
        dispatch(setCompany(null))
        dispatch(setWorkers([]))
        setIsLoading(false)
        history.push(`/?chainid=${chainId}&lang=${lang}`)
    }

    const goToMyAccount = () => {
        //window.location.href = `/myaccount?chainid=${chainId}&lang=${urlParams.get("lang") || "eng"}`;
        history.push(`/myaccount?chainid=${chainId}&lang=${urlParams.get("lang") || "eng"}`);
    }

    const checkChain = async () => {
        if(company && chainId){
            let res = await apiService.getCompany(company.companyId, chainId);
            if(res.data?.data?.length > 0){ // no company in chain
                return true
            }
        }

        logout();
        return false;
    }
    
    return (
        checkChain() && 
        <div className="comp-logged">
            <span className="company-logged-user">
                {company && company.companyLogoUrl ?
                    <img className='company-logo' src={company.companyLogoUrl}></img> :
                    <span className="greeting_txt"></span>
                }
                <span className='greeting' role="application" aria-roledescription={t("Greeting")} aria-label={`${t("Hello")} ${companyUser.customerFirstName + " " + companyUser.customerLastName}`}>{t("Hello")} {companyUser.customerFirstName + " " + companyUser.customerLastName}</span>
                <Button className="company-logout-btn" variant="outline-dark" disabled={isLoading} aria-label={t("Logout")} onClick={logout}>{t("Logout")}</Button>
            </span>
            <button className="company-account-btn" variant="outline-dark" aria-label={t("GoToMyAccount")} onClick={(e) => goToMyAccount()}>
                <img src='../images/account-icon.png' alt="" />
                <span>{t("GoToMyAccount")}</span>
            </button>
        </div>
    )
}

export default CompanyHeader